import { render, staticRenderFns } from "./AdminSteps.vue?vue&type=template&id=28536083&"
import script from "./AdminSteps.vue?vue&type=script&lang=ts&"
export * from "./AdminSteps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports